import React, { Suspense, lazy } from 'react';
import { SiteHeader } from '../components/SiteHeader';
import { Hero } from '../components/Hero';
import { Marquee } from '../components/Marquee';
import { StatsBar } from '../components/StatsBar';
import { ServicesSection } from '../components/ServicesSection';

// Everything below the fold is code-split so the first paint ships less JS.
const WorkSection = lazy(() => import('../components/WorkSection').then(m => ({
  default: m.WorkSection
})));
const ProcessSection = lazy(() => import('../components/ProcessSection').then(m => ({
  default: m.ProcessSection
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const FaqSection = lazy(() => import('../components/FaqSection').then(m => ({
  default: m.FaqSection
})));
const ContactSection = lazy(() => import('../components/ContactSection').then(m => ({
  default: m.ContactSection
})));
const SiteFooter = lazy(() => import('../components/SiteFooter').then(m => ({
  default: m.SiteFooter
})));
const ChatWidget = lazy(() => import('../components/ChatWidget').then(m => ({
  default: m.ChatWidget
})));
function SectionFallback({
  tone = 'light'
}: {
  tone?: 'light' | 'dark';
}) {
  return <div className={`min-h-[420px] w-full ${tone === 'dark' ? 'bg-ink' : 'bg-ivory'}`} aria-hidden="true" data-id="element-235" data-mp="2r0g8je9lulfa" />;
}
export function Home() {
  return <div className="min-h-screen w-full bg-ivory font-heading antialiased" data-id="element-236" data-mp="2hzi4ivz62dwp">
      <SiteHeader data-id="element-237" data-mp="2d65sdlbobzku" />
      <main data-id="element-238" data-mp="2d5mcsb9hxn9z">
        <Hero data-id="element-239" data-mp="2d545mjlapona" />
        <Marquee data-id="element-240" data-mp="2d5dw08a95xti" />
        <StatsBar data-id="element-241" data-mp="287ui59hgvn23" />
        <ServicesSection data-id="element-242" data-mp="287cbrk13bsgg" />
        <Suspense fallback={<SectionFallback tone="dark" data-id="element-244" data-mp="2861du0ubtex9" />} data-id="element-243" data-mp="288nfxkyg7283">
          <WorkSection data-id="element-245" data-mp="239spbwu8o9df" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-247" data-mp="2376k43utm5yd" />} data-id="element-246" data-mp="23auc2ykmakaz">
          <ProcessSection data-id="element-248" data-mp="1z7xosuk4u00p" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-250" data-mp="1z98u4yt87ftx" />} data-id="element-249" data-mp="1z6mlswyigwan">
          <TestimonialsSection data-id="element-251" data-mp="1u7t936r1t9bj" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-253" data-mp="1uap7ew6t600i" />} data-id="element-252" data-mp="1u94k9rmtpjco">
          <FaqSection data-id="element-254" data-mp="1kk7dgm11iwbj" />
        </Suspense>
        <Suspense fallback={<SectionFallback tone="dark" data-id="element-256" data-mp="1kn3falg0e559" />} data-id="element-255" data-mp="1kjfindf9p2mb">
          <ContactSection data-id="element-257" data-mp="1omkit9bvks7s" />
        </Suspense>
      </main>
      <Suspense fallback={null} data-id="element-258" data-mp="1ojzhqmjeigb3">
        <SiteFooter data-id="element-259" data-mp="1anciue7w1g2j" />
      </Suspense>
      <Suspense fallback={null} data-id="element-260" data-mp="1ao46n2v8u9i9">
        <ChatWidget data-id="element-261" data-mp="1flmgcvh34srb" />
      </Suspense>
    </div>;
}